import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import { logo } from '../../assets/img/dashCategoris'
import { BACKEND_URL_PREFIX } from '../../utils/const'
import { layout } from '../../actions/layout'
import { useDispatch, useSelector } from 'react-redux'

const Layout = ({children}) => {
  
  const dispatch = useDispatch()
  const { GOU_Name } = useSelector(state => state.layout.data)

  useEffect(() => {
    if (GOU_Name) return;
    dispatch(layout())
  }, [])
  
  
  return (
    <div className={styles.wrapper}>
      <div>
        <img className='header__logo' src={`${BACKEND_URL_PREFIX}/company/gou_logo`} alt='Логотип' />
        <p>{GOU_Name}</p>
        <img src={logo} alt="logo" />
      </div>
      {children}
    </div>
  )
}

export default Layout